import React, { FC } from 'react'

import Price from '../../Price'

type BoldPriceProps = {
  value: number
}

const BoldPrice: FC<BoldPriceProps> = ({ value }) => (
  // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
  <Price className="f3-ns f4-s fw7 c-on-base" value={value} />
)

export default BoldPrice
